export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8961.22821250.jpg";